















import { Component, Vue, Prop } from 'vue-property-decorator';

@Component({
  components: {}
})
export default class ToolBox extends Vue {
  @Prop() private title!: string;
}
